"use strict";

angular.module('app.accountSettings.subscriptionsListService', [])
    .factory('app.accountSettings.subscriptionsListService', [
        '$http',
        function ($http) {
            let service = {
                list: null,
                error: null,
                retrieve: function () {
                    return $http.get(window.location.api('my_account/data/subscriptions'))
                        .then(
                            function (response) {
                                let data = response.data;
                                service.list = null;

                                if (data.error) {
                                    service.error = data.error;
                                }

                                if (data.subscriptions) {
                                    service.list = data.subscriptions;
                                }
                            },
                            function (response) {
                                let data = response.data;

                                if (data && data.error) {
                                    service.error = data.error;
                                }
                                else {
                                    service.error = 'Failed to retrieve subscription history.'
                                }
                            }
                        );
                }
            };

            return service;
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/accountSettings/subscriptionsListService.js